module.exports = __webpack_public_path__ + "img/ic_history.a50dc9b2.svg";